<ex-badge [text]="'tenders.badge.' + tenderType | translate"
          backgroundColor="{{config[style].backgroundColor}}"
          color="{{config[style].color}}"
          [borderColor]="config[style].borderColor"
/>


